export default __webpack_public_path__ + "static/media/arrow.c01c75b1.svg";